export const OFFERABLE_VEHICLES_GRID_CODE = 'interest-vehicle-list';
